"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var operators_1 = require("rxjs/operators");

var base_delivery_query_service_1 = require("./base-delivery-query.service");

var QueryService =
/** @class */
function (_super) {
  __extends(QueryService, _super);

  function QueryService(config, httpService, richTextHtmlParser, sdkInfo) {
    return _super.call(this, config, httpService, richTextHtmlParser, sdkInfo) || this;
  }
  /**
   * Gets single item from given url
   * @param url Url used to get single item
   * @param queryConfig Query configuration
   */


  QueryService.prototype.getSingleItem = function (url, queryConfig) {
    var _this = this;

    return this.getResponse(url, queryConfig).pipe(operators_1.map(function (response) {
      return _this.responseMapper.mapSingleResponse(response, queryConfig);
    }));
  };
  /**
   * Gets multiple items from given url
   * @param url Url used to get multiple items
   * @param queryConfig Query configuration
   */


  QueryService.prototype.getMultipleItems = function (url, queryConfig) {
    var _this = this;

    return this.getResponse(url, queryConfig).pipe(operators_1.map(function (response) {
      return _this.responseMapper.mapMultipleResponse(response, queryConfig);
    }));
  };
  /**
   * Gets single content type from given url
   * @param url Url used to get single type
   * @param queryConfig Query configuration
   */


  QueryService.prototype.getSingleType = function (url, queryConfig) {
    var _this = this;

    return this.getResponse(url, queryConfig).pipe(operators_1.map(function (response) {
      return _this.responseMapper.mapSingleTypeResponse(response);
    }));
  };
  /**
   * Gets multiple content types from given url
   * @param url Url used to get multiple types
   * @param queryConfig Query configuration
   */


  QueryService.prototype.getMultipleTypes = function (url, queryConfig) {
    var _this = this;

    return this.getResponse(url, queryConfig).pipe(operators_1.map(function (response) {
      return _this.responseMapper.mapMultipleTypeResponse(response);
    }));
  };
  /**
   * Gets single taxonomy from given url
   * @param url Url used to get single taxonomy
   * @param queryConfig Query configuration
   */


  QueryService.prototype.getTaxonomy = function (url, queryConfig) {
    var _this = this;

    return this.getResponse(url, queryConfig).pipe(operators_1.map(function (response) {
      return _this.responseMapper.mapTaxonomyResponse(response);
    }));
  };
  /**
   * Gets multiple taxonomies from given url
   * @param url Url used to get multiple taxonomies
   * @param queryConfig Query configuration
   */


  QueryService.prototype.getTaxonomies = function (url, queryConfig) {
    var _this = this;

    return this.getResponse(url, queryConfig).pipe(operators_1.map(function (response) {
      return _this.responseMapper.mapTaxonomiesResponse(response);
    }));
  };
  /**
   * Gets single content type element from given url
   * @param url Url used to get single content type element
   * @param queryConfig Query configuration
   */


  QueryService.prototype.getElement = function (url, queryConfig) {
    var _this = this;

    return this.getResponse(url, queryConfig).pipe(operators_1.map(function (response) {
      return _this.responseMapper.mapElementResponse(response);
    }));
  };

  return QueryService;
}(base_delivery_query_service_1.BaseDeliveryQueryService);

exports.QueryService = QueryService;